"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentersCoverDetailsDisplayWidget = void 0;
var components_1 = require("@athena-portal/components");
var FalconAccordion_1 = require("../../../components/FalconAccordion");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var commonFunctions_1 = require("../../../commonFunctions");
var React = require("react");
var RentersCoverDetailsDisplayWidget = exports.RentersCoverDetailsDisplayWidget = /** @class */ (function (_super) {
    __extends(RentersCoverDetailsDisplayWidget, _super);
    function RentersCoverDetailsDisplayWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RentersCoverDetailsDisplayWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("furnishingType");
        this.fetchLookupValues("realEstateTypeSubType");
    };
    RentersCoverDetailsDisplayWidget.prototype.render = function () {
        return (React.createElement("div", { className: "section-panel text-center" },
            React.createElement("div", { className: "panel-preview-area" },
                React.createElement("img", { className: "icon-extra-lg", alt: "renters-icon", "aria-hidden": "true", src: "/img/Flow-renters.svg" }),
                React.createElement("h2", null, "Insured address:"),
                React.createElement("h5", null, (0, commonFunctions_1.getAddressLines)(this.props.interaction.realEstates[0].address).join(", ")),
                React.createElement("div", { className: "mt-3 panel-detail-output-entity" },
                    React.createElement(FalconAccordion_1.FalconAccordion, { toggleHidden: React.createElement("div", { className: "toggle" }, "+ Show more"), toggleShown: React.createElement("div", { className: "toggle mt-3" }, "- Show less") },
                        this.renderCoverDetailsSection(),
                        this.renderResidentsSection(),
                        this.renderSpecifiedItemsSection())))));
    };
    RentersCoverDetailsDisplayWidget.prototype.renderCoverDetailsSection = function () {
        var realEstate = this.props.interaction.realEstates[0];
        var furnishingType = realEstate && realEstate.furnishingType ? this.resolveLookupValue("furnishingType", realEstate.furnishingType) : "";
        var realEstateSubType = realEstate && realEstate.realEstateTypeSubType ? this.resolveLookupValue("realEstateTypeSubType", realEstate.realEstateTypeSubType).toLowerCase() : "";
        var accidentalDamageWording = this.props.interaction.factors.accidentalDamageProtection ? "Included" : "Not included";
        return (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Your property"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" },
                    furnishingType,
                    " ",
                    realEstateSubType,
                    React.createElement("br", null),
                    this.getBedroomBathroomWording(realEstate))),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Contents cover limit"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.insuredValue))),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Excess"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" },
                    "\u00A3",
                    this.props.interaction.factors.excessAmount)),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Accidental damage"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, accidentalDamageWording))));
    };
    RentersCoverDetailsDisplayWidget.prototype.renderResidentsSection = function () {
        var realEstate = this.props.interaction.realEstates[0];
        var otherResidentsWording;
        if (realEstate.hasNoOtherResidents) {
            otherResidentsWording = "None";
        }
        else {
            var familyMemberWording = realEstate.adultFamilyMemberCount + (realEstate.adultFamilyMemberCount === 1 ? " family member and " : " family members and ");
            var housemateWording = realEstate.housemateCount + (realEstate.housemateCount === 1 ? " housemate" : " housemates");
            otherResidentsWording = familyMemberWording + housemateWording;
        }
        return (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "section-heading text-blue-green" }, "Other residents"),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Adults over the age of 18"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, otherResidentsWording)),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Children under the age of 18"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, realEstate.childrenAtProperty ? "Yes" : "No"))));
    };
    RentersCoverDetailsDisplayWidget.prototype.renderSpecifiedItemsSection = function () {
        var valuableItems = this.props.interaction.valuableItems.filter(function (valuableItem) { return !valuableItem.removed; });
        if (valuableItems && valuableItems.length > 0) {
            var items = valuableItems.map(function (item, index) {
                return (React.createElement("div", { key: item.valuableItemId },
                    index !== 0 && React.createElement("div", { className: "dashed-10 my-4" }),
                    React.createElement("div", null, item.description),
                    React.createElement("div", null,
                        React.createElement("b", null, "Cover inside and outside the home"),
                        " for ",
                        React.createElement("b", null,
                            "\u00A3",
                            item.value)),
                    React.createElement("div", null,
                        "Monthly price: ",
                        React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(item.premium)))));
            });
            return (React.createElement("div", { className: "section text-left" },
                React.createElement("div", { className: "section-heading text-blue-green" }, "Specified items"),
                React.createElement("p", null,
                    "You have added ",
                    React.createElement("b", null, valuableItems.length),
                    " out of 10 items worth in total of ",
                    React.createElement("b", null,
                        "\u00A3",
                        (0, commonFunctions_1.calculateValuablesTotalValue)(valuableItems))),
                React.createElement.apply(React, __spreadArray(["div", { className: "mt-2 p-3 bg-white-blue rounded" }], items, false))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    RentersCoverDetailsDisplayWidget.prototype.getBedroomBathroomWording = function (realEstate) {
        if (realEstate.bathroomCount && realEstate.bedroomCount) {
            var bedroomWording = realEstate.bedroomCount === 1 ? " bedroom and " : " bedrooms and ";
            var bathroomWording = realEstate.bathroomCount === 1 ? " bathroom" : " bathrooms";
            return "with " + realEstate.bedroomCount + bedroomWording + realEstate.bathroomCount + bathroomWording;
        }
        return "";
    };
    RentersCoverDetailsDisplayWidget = __decorate([
        components_1.authorize
    ], RentersCoverDetailsDisplayWidget);
    return RentersCoverDetailsDisplayWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
//# sourceMappingURL=RentersCoverDetailsDisplayWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/RentersCoverDetailsDisplayWidget.js
// module id = 2577
// module chunks = 0